/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const TOOL_ID = "irgx4dnt";

/** 游戏 id，与地图资源包中的 game.id 保持一致 */
export const GAME_ID = "5801";

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType（map=3, wiki=1） */
export const TOOL_TYPE = 3; // map

export const env = {
  uid: "0", // 用户 uid, 用于日志上下文或登录校验
};
